import { createContext } from 'react'

export const RefetchContext = createContext()
